<script setup>
import { defineProps, defineEmits, computed, ref } from "vue";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
const listenStore = useListenConfigStore();

const imageMap = computed(() => imageConfig[theme.value]);

const theme = computed(() => listenStore.theme);

const $emit = defineEmits(["prevStep", "nextStep", "endStudy"]);

const props = defineProps(["step", "stepList"]);

const timer = ref(true)

const setTimer = ()=>{
  timer.value = false;
  setTimeout(()=>{
    timer.value = true
    clearTimeout()
  },500)
}

//上一个环节
const handlePrevStep = () => {
  if(!timer.value) return;
  $emit("prevStep");
  setTimer()
};

//下一个环节
const handleNextStep = () => {
  if(!timer.value) return;
  $emit("nextStep");
  setTimer()
};

//结束学习
const handleEndStudy = () => {
  $emit("endStudy");
};

//跳转到指定环节
const toStep = (obj) => {
  if(!timer.value) return;
  setTimer()
  if (obj.finished && obj.code != props.step) {
    $emit("toStep", obj.code);
  }
};
</script>

<template>
  <div class="step-box">
    <!--  上一步  -->
    <img v-if="step <= 1" src="@/assets/listening/step-prev.svg" alt="" />
    <img v-else :src="imageMap.step_prev_active" alt="" @click="handlePrevStep" />

    <div class="step-item">
      <div class="step-item_inner" v-for="item in stepList" :key="item.code">
        <span
          class="step-item_label"
          :class="{ active: item.code == step, finished: item.finished }"
          @click="toStep(item)"
        >{{ item.name }}</span>
        <img v-if="item.finished && item.code < 4" :src="imageMap.arrow_line_active" alt="" />
        <img
          v-if="item.code < 4 && !item.finished"
          src="@/assets/listening/arrow-line.svg"
          alt=""
        />
      </div>
    </div>

    <!--  下一步  -->
    <img v-if="step < 4" :src="imageMap.step_next_active" alt="" @click="handleNextStep" />
    <img v-else :src="imageMap.step_end" alt="" @click="handleEndStudy" />
  </div>
</template>

<style scoped lang="less">
@import "ThemeTag/listenTheme";
.step-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 0.64rem;
  padding: 0.64rem 0;
  height: 3rem;
  img {
    width: 1.78rem;
    height: 1.78rem;
  }
  .step-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.76rem;
    border-radius: 0.5rem;
    border: 1px solid var(--step-border-color);
    padding: 0.25rem;
    &_inner {
      display: inline-flex;
      align-items: center;
      &:last-child {
        .step-item_label {
          margin-right: 0;
        }
      }
    }
    &_label {
      width: 1.27rem;
      height: 1.27rem;
      line-height: 1.27rem;
      margin-right: 0.76rem;
      background-color: var(--step-item-bg);
      color: var(--step-item-color);
      display: inline-block;
      text-align: center;
      border-radius: 0.25rem;
      font-size: 0.76rem;
      &.active {
        background-color: var(--step-hight-light-bg-color) !important;
        color: white !important;
      }
      &.finished {
        background-color: var(--step-finished-bg);
        color: var(--step-text-color-active);
      }
    }
    img {
      width: 2.1rem;
      height: 1rem;
    }
  }
}
</style>
